import { render, staticRenderFns } from "./wxfemaleheader.vue?vue&type=template&id=1a8f9f33&scoped=true&"
import script from "./wxfemaleheader.vue?vue&type=script&lang=js&"
export * from "./wxfemaleheader.vue?vue&type=script&lang=js&"
import style0 from "./wxfemaleheader.vue?vue&type=style&index=0&id=1a8f9f33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8f9f33",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a8f9f33')) {
      api.createRecord('1a8f9f33', component.options)
    } else {
      api.reload('1a8f9f33', component.options)
    }
    module.hot.accept("./wxfemaleheader.vue?vue&type=template&id=1a8f9f33&scoped=true&", function () {
      api.rerender('1a8f9f33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wxreport/components/wxfemaleheader.vue"
export default component.exports